/**
 * API Configuration
 * Single source of truth for backend URL and API settings
 */

// Backend URL - enforce presence in production builds
const envBackend = process.env.REACT_APP_BACKEND_URL;
if (process.env.NODE_ENV === 'production' && !envBackend) {
  throw new Error('REACT_APP_BACKEND_URL is required in production builds');
}

// In development, allow localhost fallback for convenience
// Remove trailing slash to prevent double-slash issues (e.g., "https://api.example.com//api/auth")
const rawBackendUrl = envBackend || 'http://localhost:3333';
export const BACKEND_URL = rawBackendUrl.endsWith('/') ? rawBackendUrl.slice(0, -1) : rawBackendUrl;

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  auth: {
    login: `${BACKEND_URL}/api/auth/login`,
    register: `${BACKEND_URL}/api/auth/register`,
    verifyEmail: `${BACKEND_URL}/api/auth/verify-email`,
    forgotPassword: `${BACKEND_URL}/api/auth/forgot-password`,
    resetPassword: `${BACKEND_URL}/api/auth/reset-password`,
    resendOtp: `${BACKEND_URL}/api/auth/resend-otp`,
    me: `${BACKEND_URL}/api/auth/me`,
  },
  
  // Subscription
  subscription: {
    status: `${BACKEND_URL}/api/subscription/status`,
    createCheckout: `${BACKEND_URL}/api/subscription/create-checkout-session`,
    createPortal: `${BACKEND_URL}/api/subscription/create-portal-session`,
    cancel: `${BACKEND_URL}/api/subscription/cancel`,
  },
  
  // Trips
  trips: {
    base: `${BACKEND_URL}/api/trips`,
    upload: `${BACKEND_URL}/api/trips/upload`,
    analytics: `${BACKEND_URL}/api/trips/analytics`,
  },
  
  // Vehicles (Cars)
  vehicles: {
    base: `${BACKEND_URL}/api/cars`,
  },
  
  // Co-hosts
  cohosts: {
    base: `${BACKEND_URL}/api/cohosts`,
  },
  
  // Cohost Payouts (Finance Hub)
  cohostPayouts: {
    cycles: `${BACKEND_URL}/api/cohost-payouts/cycles`,
    payments: `${BACKEND_URL}/api/cohost-payouts/payments`,
    dashboard: `${BACKEND_URL}/api/cohost-payouts/dashboard`,
    forecast: `${BACKEND_URL}/api/cohost-payouts/dashboard/forecast`,
  },
  
  // Share links / Public reports
  share: {
    base: `${BACKEND_URL}/api/share`,
    public: `${BACKEND_URL}/api/share/public`,
  },
  
  // Misc Earnings
  miscEarnings: {
    base: `${BACKEND_URL}/api/misc-earnings`,
  },
  
  // Onboarding
  onboarding: {
    complete: `${BACKEND_URL}/api/users/onboarding-complete`,
    verify: `${BACKEND_URL}/api/auth/verify-email`,
  },
};

// Default fetch timeout in milliseconds
export const DEFAULT_TIMEOUT = 30000;

// Helper to build API URL with query params
export const buildApiUrl = (baseUrl, params = {}) => {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
};

export default BACKEND_URL;
